<h2 mat-dialog-title class="confirmation-dialog__title">
  <span class="material-icons confirmation-dialog__icon confirmation-dialog__icon--{{ data.iconVariant ?? data.variant ?? 'danger' }}">{{ data.icon ?? 'warning' }}</span>
  {{ data.title }}
</h2>

<mat-dialog-content class="confirmation-dialog__content">
  <p>{{ data.message }}</p>

  @if (data.checkboxLabel) {
    <label class="confirmation-dialog__checkbox">
      <input type="checkbox" [checked]="checked()" (change)="checked.set(!checked())" />
      <span>{{ data.checkboxLabel }}</span>
    </label>
  }
</mat-dialog-content>

<mat-dialog-actions class="confirmation-dialog__actions" align="end">
  <htx-button variant="tertiary" size="small" (buttonClick)="onCancel()">
    {{ data.cancelText }}
  </htx-button>
  <htx-button
    [variant]="data.variant || 'danger'"
    size="small"
    icon="power_settings_new"
    [disabled]="confirmDisabled"
    (buttonClick)="onConfirm()"
  >
    {{ data.confirmText }}
  </htx-button>
</mat-dialog-actions>
